module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo--white-46eadd88693c26444b0f14da3ef56b30.svg";